// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-1268df56{to{stroke-dashoffset:0}}.qr-code[data-v-1268df56]{background-color:#05d3be;border-radius:10px;box-shadow:0 10px 10px 0 rgba(0,0,0,.2);margin-bottom:2px;width:120px}.qr-code img[data-v-1268df56]{height:100%;padding:5px 5px 0;width:100%}.qr-code .title[data-v-1268df56]{color:#fff;font-weight:700;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
